<template>
      <transition-group name="fade" tag="div" class="notifications-box position-fixed end-0 top-0 p-2 d-flex flex-column gap-2">
      <div v-for="(notice, index) in this.MESSAGES"
           :key="notice.id"
           class="notice align-items-center rounded-2 shadow opacity-75"
           :class="notice.error ? 'text-bg-danger border-danger' : 'text-bg-success border-success'">
        <div class="d-flex">
          <div class="p-2">{{notice.text}}</div>
          <button @click="removeNotice(index)" type="button" class="btn-close btn-close-white me-2 m-auto"></button>
        </div>
        <div v-show="notice.code" class="border-top border-1 border-white p-2 small">
          {{notice.code}}
        </div>
      </div>
      </transition-group>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: "Notifications",
  computed: {
    ...mapGetters(['MESSAGES'])
  },
  data() {
    return {

    }
  },
  methods: {
    removeNotice(index) {
      this.$store.commit('delNotice', index)
    },
  },
  watch: {
    'MESSAGES': {
      handler() {

      },
      deep: true
    },
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out;
  transform: scaleY(1);
}

.fade-enter-from,
.fade-leave-to {
  transition: all 0.5s ease-in-out;
  transform: scaleY(0);
}
</style>
